import About from './pages/About';
import LandingPage from './pages/LandingPage';
import Wiki from './pages/Wiki.jsx';
import Updates from './pages/Updates.jsx';
import Rules from './pages/Rules';
import FAQ from './pages/FAQ';
import HowTo from './pages/HowTo';
import Staff from './pages/Staff';
import Applications from './pages/Applications';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import Admin from './pages/Admin';
import Header from './components/Header';
import Footer from './components/Footer';
import Zeni from './pages/Zeni';
import Vote from './pages/Vote.jsx';

import Maintenance from './pages/Maintenance.jsx';
import NotFound from './pages/NotFound.jsx';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from '@/components/ui/sonner';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

const App = () => {
  // Maintenance mode is a deploy-time switch, not a code change: set the
  // VITE_MAINTENANCE repository variable to "true" and re-run the deploy
  // workflow. Anything else — including unset — serves the real site, so the
  // default is "live" and turning the site off is the deliberate act.
  //
  // Read inside the component rather than at module scope so tests can stub it.
  // Vite inlines this at build time, so flipping it needs a rebuild.
  const inMaintenance = import.meta.env.VITE_MAINTENANCE === 'true';

  return (
    <Router>
        <ScrollToTop />
        <Header />
          <Routes>
            <Route path="/" element={inMaintenance ? <Maintenance /> : <LandingPage />} />
            {/* Reachable regardless of the flag, so the page can be previewed
                and linked without taking the site down to see it. */}
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/home" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/wiki" element={<Wiki />} />
            <Route path="/updates" element={<Updates />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/howto" element={<HowTo />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/admin" element={<Admin />} />
            <Route path='/zeni' element={<Zeni />} />
            <Route path='vote' element={<Vote/> } />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        <Footer />
        <Toaster position="bottom-right" />
    </Router>
  );
};

export default App;

